import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import api from "@/lib/api";
import { Bell } from "lucide-react";

const KIND_LABEL = {
  rfq_new: "New RFQ",
  quote_new: "Quote received",
  rfq_awarded: "RFQ awarded",
  rfq_expired: "RFQ expired",
  ticket_new: "New ticket",
  ticket_reply: "Ticket reply",
  ticket_resolved: "Ticket resolved",
  invite_sent: "Team invite",
  award: "Order awarded",
  order_update: "Order update",
  order_tax_set: "Tax breakdown",
  order_invoice_submitted: "Invoice received",
  order_buyer_marked_paid: "Payment sent",
  order_settled: "Payment confirmed",
  order_disputed: "Order disputed",
  order_milestone: "Order milestone",
  order_delivered: "Delivery",
  verification: "Verification",
  verification_approved: "Verified",
  verification_rejected: "Rejected",
};

const route = (n) => {
  const meta = n.meta || {};
  if ((n.kind || "").startsWith("rfq_") && meta.rfq_id) return `/app/rfqs/${meta.rfq_id}`;
  if ((n.kind || "").startsWith("ticket_") && meta.ticket_id) return `/app/tickets/${meta.ticket_id}`;
  if ((n.kind || "").startsWith("quote_") && meta.rfq_id) return `/app/rfqs/${meta.rfq_id}`;
  if (n.kind === "rfq_awarded" && meta.order_id) return `/app/orders/${meta.order_id}`;
  if ((n.kind || "").startsWith("order_") && meta.order_id) return `/app/orders/${meta.order_id}`;
  if (n.kind === "award" && meta.order_id) return `/app/orders/${meta.order_id}`;
  if (n.kind === "verification_approved" || n.kind === "verification_rejected" || n.kind === "verification") return `/app/company`;
  if (n.kind === "invite_sent") return "/app/team";
  return "/app/notifications";
};

export default function NotificationBell() {
  const [open, setOpen] = useState(false);
  const [items, setItems] = useState([]);
  const nav = useNavigate();

  const load = async () => {
    try { const { data } = await api.get("/notifications?limit=8"); setItems(data); } catch {}
  };
  useEffect(() => { load(); const t = setInterval(load, 15000); return () => clearInterval(t); }, []);

  const unread = items.filter(n => !n.read).length;

  const click = async (n) => {
    setOpen(false);
    if (!n.read) await api.post(`/notifications/${n.id}/read`).catch(() => {});
    nav(route(n));
    load();
  };

  return (
    <div style={{ position: "relative" }}>
      <button data-testid="notif-bell" onClick={() => setOpen(o => !o)} className="btn btn-ghost" style={{ padding: "6px 10px", position: "relative" }}>
        <Bell size={16} />
        {unread > 0 && (
          <span data-testid="notif-bell-count" style={{ position: "absolute", top: -4, right: -4, background: "var(--amber-500)", color: "var(--navy-900)", fontSize: 10, fontWeight: 700, borderRadius: 10, padding: "1px 6px", lineHeight: 1.4 }}>
            {unread}
          </span>
        )}
      </button>
      {open && (
        <div data-testid="notif-bell-dropdown" style={{ position: "absolute", right: 0, top: "calc(100% + 8px)", width: 360, maxHeight: 480, overflow: "auto", background: "var(--navy-800)", border: "1px solid var(--line)", borderRadius: 4, boxShadow: "0 12px 32px rgba(0,0,0,.5)", zIndex: 50 }}>
          <div style={{ padding: "12px 16px", borderBottom: "1px solid var(--line)", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <span className="font-mono" style={{ fontSize: 11, letterSpacing: ".1em", color: "var(--amber-400)" }}>NOTIFICATIONS · {items.length}</span>
            <Link to="/app/notifications" data-testid="notif-bell-view-all" onClick={() => setOpen(false)} style={{ fontSize: 11, color: "var(--ink-dim)", textDecoration: "none" }}>View all →</Link>
          </div>
          {items.length === 0 ? (
            <div style={{ padding: 24, textAlign: "center", color: "var(--ink-mute)", fontSize: 13 }}>No notifications.</div>
          ) : items.map(n => (
            <div key={n.id} data-testid={`bell-item-${n.id}`} onClick={() => click(n)}
                 style={{ padding: "10px 16px", borderBottom: "1px solid var(--line)", fontSize: 13, color: "var(--ink-dim)", cursor: "pointer", background: !n.read ? "rgba(245,158,11,.05)" : "transparent" }}>
              <div style={{ color: !n.read ? "var(--ink)" : "var(--ink-dim)" }}>{n.message}</div>
              <div className="font-mono" style={{ fontSize: 10, color: "var(--ink-mute)", marginTop: 4 }}>{KIND_LABEL[n.kind] || n.kind} · {new Date(n.created_at).toLocaleString()}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
